export default "__VITE_PUBLIC_ASSET__67676ec9__"